"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InfoItem = _interopRequireDefault(require("@/components/Store/InfoItem.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step5 培训记录 page
 */
/** components */
var _default2 = exports.default = {
  components: {
    InfoItem: _InfoItem.default
  },
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 表单信息，所有步骤用一个表单
    form: {
      type: Object,
      default: function _default() {
        return {
          trainingInfo: {}
        };
      }
    },
    // 表单规则
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.trainingChannelOptions: [], // 培训方式select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 是否可编辑
    canEdit: function canEdit() {
      return this.mode === 'edit';
    },
    titleTxt: function titleTxt() {
      return "".concat(this.mode === 'edit' ? this.$t('common.create') : '').concat(this.$t('storeVisitReport.step.trainingRecord'));
    },
    requiredFlag: function requiredFlag() {
      return this.form.trainingInfo.trainingCourse;
    }
  },
  methods: {
    clearForm: function clearForm() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.$refs['dataForm'].resetFields();
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 保存并下一步
    onDraftAndGo: function onDraftAndGo() {
      var _this = this;
      console.log('保存并下一步');
      this.$refs['dataForm'].clearValidate();
      this.$refs['dataForm'].validate(function (valid) {
        // 培训内容没有值时非必填，手动通过校验不走form表单的总校验，否则会因为必填表单和非必填表单同时存在会导致校验不通过
        if (_this.requiredFlag && !valid) {
          _this.$message.error(_this.$t('errorValid.formError'));
          return false;
        }
        console.log('校验通过');
        _this.$emit('draftAndGo');
      });
    },
    // 下一步
    onNext: function onNext() {
      console.log('下一步');
      this.$emit('next');
    }
  }
};